import { EgenskapsTypeEnum } from './EgenskapsTypeEnum';

export class Egenskapstype {
    private static readonly quotedeEgenskapstyper: EgenskapsTypeEnum[] = [
        EgenskapsTypeEnum.TEKST,
        EgenskapsTypeEnum.DATO,
        EgenskapsTypeEnum.TID,
    ];

    public static comparator(a: Egenskapstype, b: Egenskapstype): number {
        return a.sorteringsnummer - b.sorteringsnummer;
    }

    constructor(
        readonly id: number,
        readonly kategori: number,
        readonly navn: string,
        readonly kortnavn: string,
        readonly beskrivelse: string,
        readonly veiledning: string,
        readonly egenskapstype: EgenskapsTypeEnum,
        readonly sosinvdbnavn: string,
        readonly sosinavn: string,
        readonly sorteringsnummer: number,
        readonly feltlengde: number,
        readonly desimaler: number,
        readonly min_anbefalt: number,
        readonly maks_anbefalt: number,
        readonly min: number,
        readonly maks: number,
        readonly sensitivitet: number,
        readonly viktighet: number,
        readonly egenskapstyper: Egenskapstype[],
        readonly tillatte_verdier: EgenskapTillattVerdi[],
        readonly enhet: Enhet,
        readonly dimensjon: number,
        readonly geometritype: string,
        readonly stedfestingstype: string,
        readonly retning_relevant: boolean
    ) {}

    verdiById(id: number): EgenskapTillattVerdi | undefined {
        return this.tillatte_verdier.find(tv => tv.id === id);
    }

    verdiByKortnavn(kortnavn: string): EgenskapTillattVerdi | undefined {
        return this.tillatte_verdier.find(tv => tv.kortnavn === kortnavn);
    }

    egenskapById(id: number): Egenskapstype | undefined {
        return this.egenskapstyper.find(e => e.id === id);
    }

    erEnum(): boolean {
        return (
            this.egenskapstype === EgenskapsTypeEnum.TEKSTENUM ||
            this.egenskapstype === EgenskapsTypeEnum.HELTALLENUM ||
            this.egenskapstype === EgenskapsTypeEnum.FLYTTALLENUM
        );
    }

    erTallEnum(): boolean {
        return (
            this.egenskapstype === EgenskapsTypeEnum.HELTALLENUM ||
            this.egenskapstype === EgenskapsTypeEnum.FLYTTALLENUM
        );
    }

    erHeltall(): boolean {
        return (
            this.egenskapstype === EgenskapsTypeEnum.HELTALL ||
            this.egenskapstype === EgenskapsTypeEnum.HELTALLENUM
        );
    }

    erFlyttall(): boolean {
        return (
            this.egenskapstype === EgenskapsTypeEnum.FLYTTALL ||
            this.egenskapstype === EgenskapsTypeEnum.FLYTTALLENUM
        );
    }

    erNummerisk(): boolean {
        return this.erHeltall() || this.erFlyttall();
    }

    erGeometri(): boolean {
        return this.egenskapstype === EgenskapsTypeEnum.GEOMETRI;
    }

    erDato(): boolean {
        return this.egenskapstype === EgenskapsTypeEnum.DATO;
    }

    erKortdato(): boolean {
        return this.egenskapstype === EgenskapsTypeEnum.KORTDATO;
    }

    erKlokkeslett(): boolean {
        return this.egenskapstype === EgenskapsTypeEnum.TID;
    }

    erTekst(): boolean {
        return this.egenskapstype === EgenskapsTypeEnum.TEKST;
    }

    erStruct(): boolean {
        return this.egenskapstype === EgenskapsTypeEnum.STRUKTUR;
    }

    maaQuotes(): boolean {
        return Egenskapstype.quotedeEgenskapstyper.includes(this.egenskapstype);
    }
}

export class EgenskapTillattVerdi {
    public static comparator(a: EgenskapTillattVerdi, b: EgenskapTillattVerdi): number {
        return a.sorteringsnummer - b.sorteringsnummer;
    }

    constructor(
        readonly id: number,
        readonly kortnavn: string,
        readonly verdi: string | number,
        readonly type: string,
        readonly sorteringsnummer: number
    ) {}

    toString(): string {
        return this.verdi === '' ? 'Ingen verdi' : String(this.verdi);
    }
}

export class Enhet {
    constructor(
        readonly id: number,
        readonly navn: string,
        readonly kortnavn: string
    ) {}
}
